import type { HistorySourceTypeConfig } from "./history-source-config";
import type { PlatformHistoryTwins } from "../history-platform-twins";
import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryField, HistoryGroupBy } from "./history-fields";

export const INVOICE_TEMPLATE_FIELDS = [
    HistoryField.NAME,
    HistoryField.IS_ARCHIVED,
];

const INVOICE_TEMPLATE_SOURCES: ReadonlyArray<{
    sourceType: APIProcessName;
    fields: HistoryField[];
    platformTwins: PlatformHistoryTwins;
}> = [
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_CREATE,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_CREATE_FROM_INVOICE,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_RENAME,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_ARCHIVE,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_UNARCHIVE,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_DELETE,
        fields: INVOICE_TEMPLATE_FIELDS,
        platformTwins: null,
    },
    {
        sourceType: APIProcessName.INVOICE_TEMPLATE_UPDATE_CONTENT,
        fields: [],
        platformTwins: null,
    },
];

export const invoiceTemplateSources: HistorySourceTypeConfig[] =
    INVOICE_TEMPLATE_SOURCES.map(({ sourceType, fields, platformTwins }) => ({
        sourceType,
        resourceTypeConfigs: [
            { resourceType: ResourceType.INVOICE_TEMPLATE, fields },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins,
        enabled: true,
    }));
